import { useTenantStore } from '../stores/tenantStore.js'
import { useAuthStore } from '../stores/authStore.js'
import { FEATURES } from '../lib/config/constants.js'

/**
 * Decides which contact-support UI (if any) the app should render.
 *
 * Returned value:
 *   'pending'  — neither tenant.getConfig response has resolved; render nothing
 *                so users do not see the custom button flicker in and disappear
 *                once the real flag arrives.
 *   'none'     — Intercom is enabled but the user is not authenticated yet
 *                (Intercom requires auth), and CONTACT_SUPPORT does not provide
 *                a fallback for this state — render nothing.
 *   'intercom' — Intercom is enabled and the user is authenticated; the boot
 *                effect in useAppBootstrap will manage the widget. UI consumers
 *                use this to wire Help-style buttons to Intercom('show').
 *   'custom'   — Intercom is disabled and CONTACT_SUPPORT is enabled; render
 *                the in-house SupportButton/SupportModal.
 */
export function useContactStrategy() {
  const publicLoaded = useTenantStore((s) => s.publicLoaded)
  const authedLoaded = useTenantStore((s) => s.authedLoaded)
  const isFeatureEnabled = useTenantStore((s) => s.isFeatureEnabled)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  if (!publicLoaded && !authedLoaded) return 'pending'

  const intercomEnabled = isFeatureEnabled(FEATURES.INTERCOM)
  if (intercomEnabled) {
    return isAuthenticated ? 'intercom' : 'none'
  }

  const contactSupportEnabled = isFeatureEnabled(FEATURES.CONTACT_SUPPORT)
  return contactSupportEnabled ? 'custom' : 'none'
}
